import { Collapse, Dropdown, Modal, Popover, Tooltip, Toast } from 'bootstrap';
import Cookies from 'js-cookie';
import d3 from 'd3';
import { initToastr } from '../modules/toast.js';
import registerD3Tip from '../vendor/d3.tip.js';

import '../vendor/vanilla-cookieconsent.js';

initToastr();

globalThis.d3 = d3;
globalThis.Cookies = Cookies;
globalThis.bootstrap = { Collapse, Dropdown, Modal, Popover, Tooltip, Toast };

registerD3Tip(d3);
